import { render } from "./MaintenancePage.vue?vue&type=template&id=b7aadcc4&scoped=true"
const script = {}

import "./MaintenancePage.vue?vue&type=style&index=0&id=b7aadcc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7aadcc4"]])

export default __exports__